import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EventLogsTable from "./EventLogsTable";
import { formatTime } from "../../utils/common";
import {
  GetFireDetectionlogs,
  GetQueueEventlogs,
  GetQueueLogApi,
  GetSeatMonitioringApi,
} from "../../api/api";
import axios from "axios";

function EventLogs() {
  const { id, usecasename } = useParams();
  const [loading, setLoading] = useState(false);
  const [datalogs, setDatalogs] = useState([]);
  const [imageUrl, setImageUrl] = useState("");

  const fetchDataLogs = async () => {
    setLoading(true);
    let apiCall = null;

    // Map use case names to their API functions
    switch (usecasename) {
      case "queuewaiting":
        apiCall = GetQueueLogApi(id);
        break;
      case "fire_detection":
        // apiCall = GetFireDetectionlogs(id);
        apiCall = axios.get(
          `https://visionfiredetectionapi.greymatterz.com/fire_detection_logs/${id}`
        );
        break;
      case "seat-monitoring":
        console.log("hii");
        // apiCall = GetSeatMonitioringApi(id);
        apiCall = axios.get(
          `https://us2.sourcesoftsolutions.com:8006/seat-logs?camera_id=${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer test123securetoken`,
            },
          }
        );
        break;
      case "crowd_detection":
        apiCall = axios.get(
          `https://visionemptrack.greymatterz.com/crowd_detection/crowd_logs/${id}`
        );
        break;
      case "hardhat_detection":
        apiCall = axios.get(
          `https://visionhatjacketdetectionapi.greymatterz.com/hardhat_logs/${id}`
        );
        break;
      case "jacket_detection":
        apiCall = axios.get(
          `https://visionhatjacketdetectionapi.greymatterz.com/jacket_logs/${id}`
        );
        break;
      case "fall_detection":
        apiCall = axios.get(
          `https://visionhatjacketdetectionapi.greymatterz.com/fall_logs/${id}`
        );
        break;
      case "number_plate_detection":
        apiCall = axios.get(
          `https://visionhatjacketdetectionapi.greymatterz.com/number_plate_logs/${id}`
        );
        break;
      case "facemask_detection":
        apiCall = axios.get(
          `https://visioncrowddetectionapi.greymatterz.com/facemask_logs/${id}`
        );
        break;
      case "restricted_zone":
        apiCall = axios.get(
          `https://visionqueuewaitingapi.greymatterz.com/restricted_logs/${id}`
        );
        break;
      default:
        console.warn(`No API configured for use case: ${usecasename}`);
        setLoading(false);
        return;
    }
    try {
      const response = await apiCall;
      if (response?.data?.status) {
        setDatalogs(response?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching data logs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    buildImageUrl();
    fetchDataLogs();

    // const intervalId = setInterval(() => {
    //   fetchDataLogs();
    // }, 15000);

    // return () => clearInterval(intervalId);
  }, [id, usecasename]);

  const buildImageUrl = () => {
    let url = "";
    switch (usecasename) {
      case "seat-monitoring":
        url = `https://visionemptrack.greymatterz.com/queuewaiting/${usecasename}/video_feed/${id}`;
        break;
      case "jacket_detection":
        url = `https://visionhatjacketdetectionapi.greymatterz.com/${usecasename}/video_feed/${id}`;
        break;
      case "hardhat_detection":
        url = `https://visionhatjacketdetectionapi.greymatterz.com/${usecasename}/video_feed/${id}`;
        break;
      case "fall_detection":
        url = `https://visionhatjacketdetectionapi.greymatterz.com/${usecasename}/video_feed/${id}`;
        break;
      case "number_plate_detection":
        url = `https://visionhatjacketdetectionapi.greymatterz.com/${usecasename}/video_feed/${id}`;
        break;
      // restricted_zone
      case "crowd_detection":
        url = `https://visioncrowddetectionapi.greymatterz.com/${usecasename}/video_feed/${id}`;
        break;
      case "facemask_detection":
        url = `https://visioncrowddetectionapi.greymatterz.com/${usecasename}/video_feed/${id}`;
        break;
      case "restricted_zone":
        url = `https://visionqueuewaitingapi.greymatterz.com/${usecasename}/video_feed/${id}`;
        break;
      case "fight_detection":
        url = `https://visioncrowddetectionapi.greymatterz.com/${usecasename}/video_feed/${id}`;
        break;
      default:
        url = `https://visionemptrack.greymatterz.com/${usecasename}/video_feed/${id}`;
        break;
    }
    console.log(usecasename);
    setImageUrl(url);
  };

  return (
    <>
      <div className="d-flex fullHeightCst">
        {/* LEFT SECTION */}
        <div className="leftSection">
          <div className="titleFiltrer d-flex align-items-center p-4 border-bottom bg-white">
            <div className="col-xl-7">
              <h2 className="mb-0">{usecasename}</h2>
            </div>
            <div className="col-xl-5">
              {/* <div className="d-flex gap-2">
                 <div className="d-flex flex-column mt-0" style={{ minWidth: "140px" }}>
                   <input
                     id="dateFilter"
                     type="date"
                     className="form-control"
                     value={selectedDate}
                     onChange={(e) => setSelectedDate(e.target.value)}
                     max={new Date().toISOString().split("T")[0]}
                   />
                 </div>
               </div> */}
            </div>
          </div>
          <div className="p-4">
            <h5 className="mb-3"></h5>
            <div className="cameraGrid">
              <div className="image-box bg-white">
                {imageUrl && (
                  <img src={imageUrl} alt={usecasename} className="img-fluid" />
                )}
                <div className="text-center py-2"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="rightSection bg-white border-start">
          <div className="titleFiltrer d-flex align-items-center justify-content-between p-4 border-bottom bg-white"></div>
          <EventLogsTable
            loading={loading}
            datalogs={datalogs}
            formatTime={formatTime}
          />
        </div>
      </div>
    </>
  );
}

export default EventLogs;
